import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import { Map } from 'immutable';

import TicketPurchasing from '../event_components/ticket-purchasing';

class ListEvent extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: true,
    };
  }
  toggleAttendButton = () => {
    const { event } = this.props;

    if (event.get('type') === 'google') {
      return;
    }
    this.props.onResizeComponent();
    this.setState(
      {
        openTicketing: !this.state.openTicketing,
      },
      () => this.props.onResizeComponent()
    );
  };

  render() {
    const { event, settings, onResizeComponent } = this.props;

    return (
      <Fragment>
        <TicketPurchasing event={event} settings={settings} open onResizeComponent={onResizeComponent} />
      </Fragment>
    );
  }
}

function CheckoutContainer({ events, settings, onResizeComponent }) {
  return events.map((event) => <ListEvent key={event.get('id')} event={event} settings={settings} onResizeComponent={onResizeComponent} />).toJS();
}

CheckoutContainer.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};

export default CheckoutContainer;
